// src/utils/notificationHelper.js
import { getFunctions, httpsCallable } from "firebase/functions";
import { app, db } from "../firebase";
import i18n from "../i18n";
import { doc, getDoc } from "firebase/firestore";

const functions = getFunctions(app);

// Send notification to all users with access to a child. Token lookup and
// sending happens server-side in the sendChildNotification Cloud Function —
// the client never queries the `users` collection directly.
export async function sendChildNotification(childId, action, extraData = {}) {
  try {
    const childRef = doc(db, "children", childId);
    const childSnap = await getDoc(childRef);
    if (!childSnap.exists()) throw new Error("Child not found");
    const child = childSnap.data();

    // Build message
    const { t } = i18n;
    let title = "";
    let body = "";
    if (action === "sleep_started") {
      title = t("notifications.sleep_started_title");
      body = t("notifications.sleep_started_body", { name: child.name });
    } else if (action === "sleep_stopped") {
      title = t("notifications.sleep_stopped_title");
      body = t("notifications.sleep_stopped_body", { name: child.name });
    } else if (action === "feeding_started") {
      title = t("notifications.feeding_started_title");
      body = t("notifications.feeding_started_body", { name: child.name });
    } else if (action === "feeding_stopped") {
      title = t("notifications.feeding_stopped_title");
      body = t("notifications.feeding_stopped_body", { name: child.name });
    } else if (action === "diaper_changed") {
      title = t("notifications.diaper_changed_title");
      body = t("notifications.diaper_changed_body", { name: child.name });
    } else {
      title = t("notifications.update_title");
      body = t("notifications.update_body", { name: child.name, action });
    }

    const sendNotification = httpsCallable(functions, "sendChildNotification");
    await sendNotification({ childId, title, body, data: extraData });
  } catch (err) {
    console.error("Notification error:", err);
  }
}
